import React, { Component } from "react";
import "../App.css";

export default class Footerpage extends Component {
  render() {
    return (
      <div className="has-text-centered">
        <footer className=" my-footer footerwaveshape">
          <div
            className="columns container has-text-left has-text-centered-mobile my-container my-column"
            style={{ margin: "auto" }}
          >
            <div className="column is-3">
              <div>
                <div>
                  <a href="https://codeops.tech">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/logo1.png`}
                      alt="codeops logo"
                      width="150px"
                      height="80px"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="column is-3">
              <h4 className="widget-title">Products</h4>
              <ul className="xs-list">
                <li>
                  <a
                    href="https://konfhub.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="xs-list"
                  >
                    KonfHub
                  </a>
                </li>
                <li>
                  <a
                    href="https://quiz.konfhub.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="xs-list"
                  >
                    QuizHub
                  </a>
                </li>
                <li>
                  <a href="https://awsreskill.com" className="xs-list" target="_blank">
                    re:Skill
                  </a>
                </li>
                <li>
                  <a
                    href="https://talent.awsug.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="xs-list"
                  >
                    Talent Board
                  </a>
                </li>
              </ul>
            </div>
            <div className="column is-3">
              <h4 className="widget-title">Offerings</h4>
              <ul className="xs-list">
                <li>
                  <a
                    href="https://codeops.tech/#jetbrainstools"
                    className="xs-list"
                  >
                    JetBrains Tools
                  </a>
                </li>
                <li>
                  <a
                    href="https://codeops.tech/#consulting"
                    className="xs-list"
                  >
                    Consulting
                  </a>
                </li>
                <li>
                  <a href="https://codeops.tech/#trainings" className="xs-list">
                    Trainings
                  </a>
                </li>
                <li>
                  <a
                    href="https://codeops.tech/community.html"
                    className="xs-list"
                  >
                    Community
                  </a>
                </li>
                <li>
                  <a
                    href="https://github.com/CodeOpsTechnologies/Talent-Board-Frontend"
                    className="xs-list"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open Source
                  </a>
                </li>
              </ul>
            </div>
            <div className="column is-3">
              <h4 className="widget-title"> Company</h4>
              <ul className="xs-list">
                <li>
                  <a
                    className="xs-list"
                    href="https://codeops.tech/about-us.html"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    className="xs-list"
                    href="https://codeops.tech/awards.html"
                  >
                    Awards
                  </a>
                </li>
                <li>
                  <a className="xs-list" href="mailto:reachus@codeops.tech">
                    Contact Us
                  </a>
                </li>
                <li>
                  {" "}
                  <a
                    className="xs-list"
                    href="https://codeops.tech/privacypolicy.html"
                  >
                    {" "}
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div style={{ marginTop: "1rem" }} className="has-text-centered">
            <a href="https://github.com/codeopstech">
              <i style={{ color: "black" }} className="fab fa-github"></i>{" "}
            </a>
            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
            <a href="https://www.slideshare.net/CodeOps">
              <i style={{ color: "blue" }} className="fab fa-slideshare"></i>{" "}
            </a>
            &nbsp;&nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
            <a href="https://twitter.com/CodeOpsTech">
              <i style={{ color: "#00acee" }} className="fab fa-twitter"></i>{" "}
            </a>
            &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
            <a href="https://www.linkedin.com/company/codeops-technologies">
              <i
                style={{ color: "#0e76a8" }}
                className="fab fa-linkedin-in"
              ></i>{" "}
            </a>
            &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
            <a href="https://www.youtube.com/channel/UCOS0XFWJVBMV-Zv0iNckSNg">
              <i style={{ color: "red" }} className="fab fa-youtube"></i>{" "}
            </a>
            &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
            <a href="https://www.facebook.com/CodeOpsTech/">
              <i style={{ color: "#3b5998" }} className="fab fa-facebook-f"></i>{" "}
            </a>
            <br />
            <p className="footerText">
              {" "}
              &#169; 2016 - {new Date().getFullYear()}{" "}
              <a href="https://codeops.tech" style={{ color: "#78d0e8" }}>
                CodeOps Technologies LLP
              </a>
              . All Rights Reserved.
            </p>
            <br />
          </div>
        </footer>
      </div>
    );
  }
}
